import { Injectable } from '@angular/core';
import { RealEstateDeveloper } from '../../models/real-estate-developer.model';
import { paginateMockData, triggerRandomError } from '../../utils/mock.utils';
import { Paginable } from '../../utils/pagination.utils';
import { REAL_ESTATE_DEVELOPERS_MOCK } from './real-estate-developers.mock';
import { RealEstateDevelopersPaginableParams, RealEstateDevelopersService } from './real-estate-developers.service';

@Injectable()
export class RealEstateDevelopersServiceMock implements RealEstateDevelopersService {
  async get(id: number): Promise<RealEstateDeveloper | null> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (triggerRandomError(reject)) {
          return;
        }
        resolve(REAL_ESTATE_DEVELOPERS_MOCK.find((developer) => developer.id === id) ?? null);
      }, 1000);
    });
  }

  async getAll(params: RealEstateDevelopersPaginableParams): Promise<Paginable<RealEstateDeveloper>> {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (triggerRandomError(reject)) {
          return;
        }
        const data = REAL_ESTATE_DEVELOPERS_MOCK.filter((developer) => params.tags?.every((tag) => developer.tags.includes(tag)) ?? true);
        resolve(paginateMockData(data, params));
      }, 1000);
    });
  }
}
